import { EventSecurityPlanResult } from '@types';

export const MOCK_EVENT_SECURITY_PLAN: EventSecurityPlanResult = {
    reportType: 'EventSecurityPlanResult',
    eventName: "2026 Global Tech Expo - London",
    dates: "August 15-20, 2026",
    location: {
        address: "ExCeL London, Royal Victoria Dock, 1 Western Gateway, London E16 1XL",
        lat: 51.5085,
        lng: 0.0248
    },
    executiveSummary: "The 2026 Global Tech Expo is a high-profile international event expected to attract over 50,000 attendees, including heads of industry and high-profile tech leaders. This Event Security Plan (OPORD) outlines the multi-layered security strategy designed to mitigate identified risks ranging from petty crime to targeted technical espionage and civil unrest. The primary objective is the safety of all attendees while ensuring minimal disruption to event operations.",
    userInputReview: "The user has specified a focus on VIP protection for keynote speakers and expressed concerns regarding local protest activities currently trending in the Docklands area. The proposed medical plan and logistical constraints provided by the organizer have been integrated into this operational framework.",
    localizedThreatAnalysis: {
        summary: "Current intelligence indicates a moderate threat level in the Newham borough. Recent data shows a 12% increase in pickpocketing incidents around transport hubs. Protests by 'Silicon Rights' groups are anticipated at the main entrance.",
        localRisks: [
            { 
                risk: "Opportunistic Theft", 
                level: "High", 
                impact: "High",
                description: "High volume of international visitors at the Custom House DLR station and the West Entrance makes this a prime target for organized crime groups." 
            },
            { 
                risk: "Civil Unrest", 
                level: "Medium", 
                impact: "Medium",
                description: "Anticipated 'Flash Protests' by environmental groups targeting specific tech sponsors. Protests are expected to be non-violent but disruptive to ingress." 
            },
            { 
                risk: "Technical Espionage", 
                level: "High", 
                impact: "Critical",
                description: "Presence of pre-release prototypes makes the venue a Tier-1 target for industrial espionage via rogue Wi-Fi hotspots and social engineering." 
            }
        ]
    },
    threatAssessment: {
        summary: "The overall threat level is categorized as AMBER (Moderate). While there is no specific kinetic threat to life, the risk of reputational damage and intellectual property theft is significant.",
        specificThreats: [
            { 
                threat: "Unauthorized Access to VIP Lounge", 
                likelihood: "Medium", 
                impact: "High", 
                mitigation: "Strict accreditation checks, 2-man post at entry, and biometric verification for core zones." 
            },
            { 
                threat: "Cyber Interference", 
                likelihood: "High", 
                impact: "Medium", 
                mitigation: "Frequency monitoring and signal jamming for unauthorized SSID broadcasts." 
            }
        ]
    },
    securityRiskManagementPlan: {
        methodology: "Based on ISO 31000:2018 Risk Management guidelines, utilizing a 5x5 Likelihood/Impact matrix.",
        riskMatrix: [
            { asset: "Attendees", threat: "Crowd Crush", likelihood: "Low", impact: "Critical", score: 5, mitigation: "One-way flow systems and real-time density monitoring." },
            { asset: "IP/Prototypes", threat: "Theft", likelihood: "Medium", impact: "High", score: 12, mitigation: "Locked display cases with vibration sensors and 24/7 CCTV coverage." }
        ]
    },
    operationalPlan: {
        accessControl: "Multi-zone perimeter strategy. Zone A (Public), Zone B (Exhibitors), Zone C (VIP/Backstage). Verification required at every transition point.",
        crowdManagement: "Dynamic barrier deployments at peak entry times (08:00-10:00). Trained stewards at all major thoroughfares.",
        surveillance: "Integration of ExCeL's 250+ CCTV cameras with portable temporary AI-vision units at entry points for facial recognition against 'Watch Lists'.",
        hsse: "All staff to wear high-visibility gear during build/break. Mandatory safety induction for all exhibitors."
    },
    epDetail: {
        principalProtection: "Close protection teams assigned to P1-P5 principals. Low-profile monitoring for secondary VIPs.",
        movementPlan: "Coordinated arrival via the Royal Victoria Dock waterfront to bypass potential protests at the land entrances.",
        safeHavens: "The 'Capital Suite' on Level 3 designated as the primary safe haven, reinforced with ballistically rated doors."
    },
    healthAndSafetyPlan: {
        summary: "Comprehensive HSSE framework aligned with UK HSE 'Purple Guide' for large-scale events.",
        keyProcedures: ["Emergency Evacuation Drill for staff", "Heat Stress monitoring for floor staff", "Trip hazard inspections every 4 hours"],
        complianceNotes: "Aligns with the 'Protect Duty' (Martyn's Law) guidelines for publicly accessible locations."
    },
    accessControlPlan: {
        perimeterSecurity: "Outer perimeter managed by steward teams with vehicle-borne IED (VBIED) barriers at the loading bays.",
        screeningProcedures: "100% Bag checks and semi-random 'Wand' screening for all public entrants.",
        accreditationSystem: "RFID-enabled badges with color-coded lanyards for visual triage by field teams."
    },
    staffingAndAdmin: {
        adminRequirements: "Daily field briefings at 07:00. Incident logs maintained via the SRM Monitor mobile application.",
        staffingTable: [
            { role: "Event Security Director", quantity: 1, responsibility: "Overall command and liaison with MET Police." },
            { role: "Team Leader (TL)", quantity: 4, responsibility: "Sector management and tactical dispatch." },
            { role: "EP Officer", quantity: 12, responsibility: "Close protection details." },
            { role: "Security Responder", quantity: 30, responsibility: "Static posts and roving patrols." }
        ]
    },
    c3: {
        commandStructure: "Command Post (CP) located in the ExCeL Management Office. Tactical Dispatch via encrypted UHF channel 3.",
        commsPlan: "Radios for all TLs and Responders. Secondary comms via Signal/WhatsApp for encrypted text updates."
    },
    logistics: {
        equipment: "Encrypted UHF Radios, Thermal Imaging Units, Portable Barriers, First Aid Kits.",
        medical: "On-site Medical Suite staffed by 2 Paramedics during operational hours. St. John Ambulance standby.",
        liaison: "Direct line to Newham Metropolitan Police Service (MPS) and London Fire Brigade (LFB)."
    },
    organizerContacts: [
        { role: "Project Lead", name: "Sarah Jenkins", contactInfo: "+44 20 7123 4567" }
    ],
    medicalPlan: "Primary medical post at Stand S1. Evacuation path through Gate 4 for ambulance access.",
    valetAndParking: "Designated VIP parking in Zone P3. Traffic control team at Custom House roundabout.",
    logisticsRequirements: "150 Radios, 400 linear meters of crowd railing, 10 portable lighting towers for break-down phase.",
    emergencyEvacuation: "Primary Muster Point: Custom House DLR Square. Secondary: Royal Victoria Waterfront."
};
